enum VirtualizedTableSupportedColumnWidthTypeEnum {
  PX = 'px',
  PERCENT = '%',
}

export default VirtualizedTableSupportedColumnWidthTypeEnum;
